import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureStepFieldsRevisionSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId"
					to="/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/fields"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Fields
					</Button>
				</Link>
			}
		/>
	)
})
ProcedureStepFieldsRevisionSettingsDetailViewTopBar.displayName = "ProcedureStepFieldsRevisionSettingsDetailViewTopBar"
